/* Woodmobiel — modellen-galerij modal */
(function(){
  function init(){
    var modal = document.querySelector('[data-wm-modal]');
    var cards = document.querySelectorAll('[data-wm-model]');
    try { console.log('[WM-v2] models.js loaded — cards:', cards.length, '| modal:', !!modal); } catch(e){}
    if(!modal || !cards.length) return;
    var slides = [], idx = 0;
    function render(){
      if(!slides.length) return;
      modal.querySelector('[data-wm-slide]').src = slides[idx];
      modal.querySelector('[data-wm-ind]').textContent = (idx+1) + ' / ' + slides.length;
    }
    function open(c){
      var d = c.dataset;
      modal.querySelector('[data-wm-cat]').textContent = d.cat || '';
      modal.querySelector('[data-wm-name]').textContent = d.name || '';
      modal.querySelector('[data-wm-shorttext]').textContent = d.short || '';
      modal.querySelector('[data-wm-chip]').textContent = 'Bouwhulp pagina ' + (d.page || '');
      modal.querySelector('[data-wm-longtext]').textContent = d.long || '';
      modal.querySelector('[data-wm-tip]').textContent = 'Klik door naar pagina 2 van de carousel voor de complete bouwhandleiding (pagina ' + (d.page || '') + ' uit het bouwboek).';
      modal.querySelector('[data-wm-cta]').setAttribute('href', d.shop || '#');
      var pdfKnop = modal.querySelector('[data-wm-pdf]');
      if(pdfKnop){
        if(d.pdf){ pdfKnop.setAttribute('href', d.pdf); pdfKnop.style.display = ''; }
        else { pdfKnop.style.display = 'none'; }
      }
      slides = []; if(d.img) slides.push(d.img); if(d.bh) slides.push(d.bh); idx = 0; render();
      modal.classList.add('is-open'); modal.setAttribute('aria-hidden','false'); document.body.style.overflow = 'hidden';
    }
    function close(){ modal.classList.remove('is-open'); modal.setAttribute('aria-hidden','true'); document.body.style.overflow = ''; }
    for(var i=0;i<cards.length;i++){
      (function(c){ c.addEventListener('click', function(e){ e.preventDefault(); open(c); }); })(cards[i]);
    }

    /* "Open"-knop onder de kaart: opent dezelfde pop-up als de kaart zelf */
    var openKnoppen = document.querySelectorAll('.wmg__act--open, .wmvb__act--open, .wm-gal__act--open');
    for(var j=0;j<openKnoppen.length;j++){
      (function(k){
        k.addEventListener('click', function(e){
          e.preventDefault(); e.stopPropagation();
          var wrap = k.closest('.wmg__cardwrap, .wmvb__cardwrap, .wm-gal__cardwrap');
          var kaart = wrap && wrap.querySelector('[data-wm-model]');
          if(kaart) open(kaart);
        });
      })(openKnoppen[j]);
    }
    var dis = modal.querySelectorAll('[data-wm-dismiss]');
    for(var j=0;j<dis.length;j++){ dis[j].addEventListener('click', close); }
    var pv = modal.querySelector('[data-wm-prev]'), nx = modal.querySelector('[data-wm-next]');
    if(pv) pv.addEventListener('click', function(){ if(slides.length){ idx=(idx-1+slides.length)%slides.length; render(); } });
    if(nx) nx.addEventListener('click', function(){ if(slides.length){ idx=(idx+1)%slides.length; render(); } });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape') close(); });
    var search = document.querySelector('[data-wm-search]'), none = document.querySelector('[data-wm-none]');
    if(search){
      search.addEventListener('input', function(){
        var q = search.value.trim().toLowerCase(), any = 0;
        for(var k=0;k<cards.length;k++){
          var hit = (cards[k].dataset.name || '').toLowerCase().indexOf(q) > -1;
          cards[k].style.display = hit ? '' : 'none'; if(hit) any++;
        }
        var groups = document.querySelectorAll('[data-wm-group]');
        for(var g=0;g<groups.length;g++){
          var vis = groups[g].querySelectorAll('[data-wm-model]:not([style*="none"])').length;
          groups[g].style.display = vis ? '' : 'none';
        }
        if(none) none.style.display = any ? 'none' : 'block';
      });
    }
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
